import { Routes } from '@angular/router';

import { ConfigurationsComponent } from './views/superadmin/configurations.component';

import { DashboardComponent } from './views/appviews/dashboard.component';
import { LoginComponent } from './views/user/login.component';

import { IsAuthenticatedAuthGuard } from 'app/authGuards/isAuthenticated.authGuard';
import { IsSuperadminAuthGuard } from 'app/authGuards/isSuperadmin.authGuard';
import { IsVerifiedAuthGuard } from 'app/authGuards/isVerified.authGuard';
import { UserLayoutComponent } from 'app/components/common/layouts/userLayout.component';
import { PendingChangesGuard } from 'app/components/guards/pendingChanges.guard';
import { DevicesListComponent } from 'app/views/devices/devicesList.component';
import { EditDeviceComponent } from 'app/views/devices/editDevice.component';
import { DevicesGroupsListComponent } from 'app/views/devices/groups/devicesGroupsList.component';
import { EditDevicesGroupComponent } from 'app/views/devices/groups/editDevicesGroup.component';
import { LinkDeviceComponent } from 'app/views/devices/linkDevice.component';
import { EditAccountComponent } from 'app/views/options/editAccount.component';
import { EditPresentationComponent } from 'app/views/presentations/editPresentation.component';
import { PresentationsListComponent } from 'app/views/presentations/presentationsList.component';
import { CreateAccountComponent } from 'app/views/user/createAccount.component';
import { EmailActionHandlerComponent } from 'app/views/user/emailActionHandler.component';
import { ForgotPasswordComponent } from 'app/views/user/forgotPassword.component';
import { VerifyEmailComponent } from 'app/views/user/verifyEmail.component';
import { BasicLayoutComponent } from './components/common/layouts/basicLayout.component';
import { BlankLayoutComponent } from './components/common/layouts/blankLayout.component';
import { TopNavigationLayoutComponent } from './components/common/layouts/topNavigationlayout.component';
import { WebViewComponent } from './views/devices/web-view/web-view.component';
import { WebViewGuard } from './views/devices/web-view/web-view.guard';

export const ROUTES: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        canActivate: [IsAuthenticatedAuthGuard, IsVerifiedAuthGuard, IsSuperadminAuthGuard],
        path: 'superadmin', component: BasicLayoutComponent,
        children: [
            { path: 'configurations/:deviceId', component: ConfigurationsComponent }
        ]
    },
    {
        canActivate: [IsAuthenticatedAuthGuard, IsVerifiedAuthGuard],
        path: 'pin',
        redirectTo: 'devices/link'
    },
    {
        canActivate: [IsAuthenticatedAuthGuard, IsVerifiedAuthGuard],
        path: '', component: BasicLayoutComponent,
        children: [
            { path: 'home', component: DashboardComponent }
        ]
    },
    {
        canActivate: [IsAuthenticatedAuthGuard, IsVerifiedAuthGuard],
        path: 'presentations',
        redirectTo: 'presentations/list'
    },
    {
        path: 'presentations', component: BasicLayoutComponent,
        canActivate: [IsAuthenticatedAuthGuard, IsVerifiedAuthGuard],
        children: [
            { path: 'list', component: PresentationsListComponent },
            { path: 'create', component: EditPresentationComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'edit/:id', component: EditPresentationComponent, canDeactivate: [PendingChangesGuard] }
        ]
    },
    {
        path: 'devices', component: BasicLayoutComponent,
        canActivate: [IsAuthenticatedAuthGuard, IsVerifiedAuthGuard],
        children: [
            { path: 'link', component: LinkDeviceComponent },
            { path: 'list', component: DevicesListComponent },
            { path: 'edit/:id', component: EditDeviceComponent, canDeactivate: [PendingChangesGuard] },
            {
                path: 'groups',
                canActivate: [IsAuthenticatedAuthGuard, IsVerifiedAuthGuard],
                children: [
                    { path: 'list', component: DevicesGroupsListComponent },
                    { path: ':id/list', component: DevicesListComponent },
                    { path: 'create', component: EditDevicesGroupComponent, canDeactivate: [PendingChangesGuard] },
                    { path: 'edit/:id', component: EditDevicesGroupComponent, canDeactivate: [PendingChangesGuard] }
                ]
            },
            {
                path: 'web-view', component: WebViewComponent, canActivate: [WebViewGuard]
            }
        ]
    },
    {
        path: 'user', component: UserLayoutComponent,
        children: [
            { path: 'login', component: LoginComponent },
            { path: 'createAccount', component: CreateAccountComponent },
            { path: 'emailActionHandler', component: EmailActionHandlerComponent },
            { path: 'forgotPassword', component: ForgotPasswordComponent },
            { path: 'verifyEmail', component: VerifyEmailComponent, canActivate: [IsAuthenticatedAuthGuard] }
        ]
    }, {
        path: 'account', component: BasicLayoutComponent,
        canActivate: [IsAuthenticatedAuthGuard, IsVerifiedAuthGuard],
        children: [
            { path: 'edit', component: EditAccountComponent, canDeactivate: [PendingChangesGuard] }
        ]
    },

    // Handle all other routes
    { path: '**', redirectTo: 'home' }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts